import { Box3, Color, Group, Object3D, Vector3 } from "three";
import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import * as Scenes from "oc-threejs/Scenes";
import { AbstractPart3d } from "./AbstractPart3d";
import { v3 } from "oc-threejs/short3";
import { formatM, label3d } from "../commons/Utils";
import { addFakeLightFromMMR } from "./Füllung3d";
import { Pfosten } from "../arrangement/Pfosten";
import { MyModel } from "../arrangement/MyModel";

const WHITE = new Color("white");
const BLACK = new Color("black");

export class Pfosten3d extends AbstractPart3d {
  CLASS_NAME = "Pfosten3d";
  fakeLights: Object3D[] = [];
  selectLabels: Group;
  declare jaco: Pfosten;

  constructor(jaco: Jaco) {
    super(jaco);
    this.tapable = true;
  }

  update3d() {
    super.update3d();
    if (!APP.isTorkonfigurator) {
      this.showSelectLabel();
    }
    if (this.changed("hasLichtkappe")) {
      this.updateFakeLight();
    }
  }

  async showSelectLabel() {
    if (this.changed("selected") || this.changed("getBox") || this.changed("warning")) {
      Scenes.remove(this.selectLabels);
      if (this.jaco.selected) {
        this.selectLabels = new Group();
        this.add(this.selectLabels);
        const box = this.jaco.getBox();
        // verschiebe selectLabels so, dass ihr Nullpunkt auf dem Boden liegt
        this.selectLabels.position.y = -this.jaco.localToWorld(v3(0, 0, 0)).y;
        const label = (text: string, position: Vector3, warning = false) => {
          const label = label3d(text, warning);
          label.position.copy(position);
          this.selectLabels.add(label);
        };
        label(
          `⤒${formatM(this.jaco.localToWorld(box.max.clone()).y)}`,
          box.grid(0.5, 1, 0).add(v3(0, 0.15, 0))
        );
        const elemente = this.jaco.elemente;
        const selectedIndex = elemente.findIndex((e) => e.selected);
        if (selectedIndex >= 0) {
          const links = selectedIndex == 0;
          const l = this.jaco[!links ? "gapLinks" : "gapRechts"];
          label((links ? "⇸" : "") + formatM(-l) + (links ? "" : "⇷"), v3(0, 0.05, 0.3));
        }
      }
      // TODO: Warnung wenn Sturmanker falsch ausgerichtet?
    }
  }

  updateFakeLight() {
    this.fakeLights.forEach((f) => Scenes.remove(f));
    this.fakeLights = [];
    if (this.jaco.hasLichtkappe) {
      this.addFakeLight();
    }
  }

  addFakeLight(): void {
    const pfostenkappe = this.jaco.pfostenkappe;
    if (pfostenkappe?.model) {
      const sizeCutted = (pfostenkappe.model as MyModel).getSizeCutted() as Vector3;
      const box = new Box3().setFromCenterAndSize(v3(), sizeCutted);
      addFakeLightFromMMR(this.fakeLights, pfostenkappe, box, pfostenkappe.getMeta());
    }
  }

  // @ts-ignore
  clone(recursive?: boolean) {
    return new Pfosten3d(this.jaco);
  }
}
